// Purchase-order dates arrive in two shapes: `YYYY-MM-DD` for POs parsed from
// a modern PDF, and `DD/MM/YYYY` for older imported orders. Sorting those as
// plain strings buries recent orders beneath old ones, so both the ordering and
// the displayed date go through here. Falls back to the record's created_date.

function toParts(value) {
  if (!value) return null;
  const s = String(value).trim();
  // YYYY-MM-DD (or a full ISO timestamp)
  let m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (m) return { y: +m[1], mo: +m[2], d: +m[3] };
  // DD/MM/YYYY
  m = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (m) return { y: +m[3], mo: +m[2], d: +m[1] };
  const d = new Date(s);
  if (!isNaN(d.getTime())) return { y: d.getFullYear(), mo: d.getMonth() + 1, d: d.getDate() };
  return null;
}

// Sortable timestamp — newest is largest.
export function b2bOrderTime(order) {
  const p = toParts(order?.po_date) || toParts(order?.created_date);
  return p ? new Date(p.y, p.mo - 1, p.d).getTime() : 0;
}

// dd/mm/yyyy, falling back to the system creation date.
export function fmtB2BOrderDate(order) {
  const p = toParts(order?.po_date) || toParts(order?.created_date);
  if (!p) return '—';
  return `${String(p.d).padStart(2, '0')}/${String(p.mo).padStart(2, '0')}/${p.y}`;
}

// Newest first.
export function sortB2BOrders(orders) {
  return [...(orders || [])].sort((a, b) => b2bOrderTime(b) - b2bOrderTime(a));
}